export * from './GetStaticPath';
export * from './PageBaseProps';
